import { useMutation } from '@tanstack/react-query';
import { analyticsTrack } from '../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import useApi from '../../api/backendApiContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import { useNotification } from '../../notification/notificationsContext';
import useAnalytics from '../../web-analytics/webAnalyticsContext';

export const useCreateReferralLinkMutation = () => {
  const { billingApi } = useApi();
  const queryCacheManager = useQueryCacheManager();
  const { notifySuccess, notifyError } = useNotification();
  const analytics = useAnalytics();

  return useMutation(async () => billingApi.createReferralLink(), {
    onMutate: () =>
      analyticsTrack(analytics, AnalyticsEvent.PERSONAL_REFERRAL_LINK_CREATE_REQUEST_SENT),
    onSuccess: async (response) => {
      await queryCacheManager.updateBillingCustomer({ referralLink: response });
      analyticsTrack(analytics, AnalyticsEvent.PERSONAL_REFERRAL_LINK_CREATED);
      const message = response.wasRequested
        ? 'Your request to create your personal referral link has been accepted.'
        : 'Your referral link has been created.';
      notifySuccess({ logMsg: message, notificationMsg: message });
    },
    onError: async () => {
      await queryCacheManager.invalidateBillingCustomer();
      analyticsTrack(analytics, AnalyticsEvent.PERSONAL_REFERRAL_LINK_CREATE_FAILED);
      const message = `Something went wrong. Please try to submit the request to create your personal referral link later or contact support.`;
      notifyError({ logMsg: message, notificationMsg: message });
    },
  });
};
